module.exports = __webpack_public_path__ + "static/media/pp-homeTablet2.5dd34397.png";